module.exports = __webpack_public_path__ + "static/media/about-us-header-image.76f13fb3.jpg";